const accountTransactionsI18n = {
  "fr": {
    "title": "Mes ventes",
    "actions": {
      "refresh": "Actualiser"
    },
    "loading": "Chargement…",
    "empty": "Aucune vente pour le moment.",
    "emptyCta": {
      "title": "Vous n’avez pas encore de vente.",
      "subtitle": "Vendez vos téléphones en quelques clics et recevez votre paiement rapidement.",
      "button": "Vendre maintenant"
    },
    "info": {
      "waybillPending": "Votre bordereau est en cours de création. Vous recevrez un mail une fois généré."
    },
    "labels": {
      "shipment": "Vente",
      "createdAt": "Créée le",
      "tracking": "Suivi",
      "trackingReturn": "Suivi retour",
      "total": "Total estimé :",
      "paid": "Montant du paiement :",
      "buyback": "Montant validé :",
      "batchSort": "Envoie ! on trie pour toi !"
    },
    "meta": {
      "packages": "colis",
      "pieces": "pièces"
    },
    "buttons": {
      "pdfRecap": "PDF Récap",
      "waybill": "Versandetikett",
      "details": "Détails",
      "hide": "Masquer"
    },
    "status": {
      "sent": "Versand",
      "received": "Réception",
      "quality": "Contrôle",
      "pdf": "PDF",
      "paid": "Paiement",
      "sentAt": "Transport :",
      "receivedAt": "Réception :",
      "qualityCheckedAt": "Contrôle :",
      "pdfRecapAt": "PDF :",
      "paidAt": "Paiement :"
    },
    "table": {
      "item": "Article",
      "unitPrice": "PU (€)",
      "qty": "Qté",
      "total": "Total (€)"
    },
    "pdf": {
      "title": "Aperçu — PDF de contrôle",
      "loading": "Chargement du PDF…",
      "unavailable": "PDF indisponible."
    },
    "waybill": {
      "title": "Aperçu — Transport",
      "loading": "Chargement du transport…",
      "unavailable": "Transport indisponible."
    },
    "files": {
      "shipment": "Vente",
      "waybill": "Transport"
    },
    "common": {
      "download": "Télécharger",
      "openInTab": "Ouvrir dans un onglet",
      "close": "Fermer"
    },
    "errors": {
      "load": "Impossible de charger vos transactions."
    },
    "contact": {
      "text": "Besoin d’aide ? Écrivez-nous à",
      "button": "Écrire",
      "inlineHelp": "Une question ? Contactez-nous :",
      "subject": "Question sur ma vente"
    },
    "filters": {
      "all": "Toutes",
      "ongoing": "En cours",
      "past": "Terminées",
      "sortLabel": "Trier",
      "emptyAfterFilter": "Aucune vente ne correspond au filtre.",
      "sort": {
        "newest": "Plus récentes",
        "oldest": "Plus anciennes",
        "amountDesc": "Montant décroissant",
        "amountAsc": "Montant croissant"
      }
    },
    "badges": {
      "paid": "Payée"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": " (enregistré)",
      "toast": {
        "title": "Moyen de paiement enregistré",
        "subtitle": "Votre IBAN a bien été sauvegardé."
      },
      "confirm": {
        "title": "Utiliser ce moyen de paiement ?",
        "savedIbanTitle": "IBAN enregistré",
        "body": "Nous utiliserons cet IBAN pour effectuer votre virement.",
        "changeIban": "Modifier l’IBAN",
        "useThis": "Utiliser"
      },
      "form": {
        "title": "Renseigner mon IBAN",
        "info": "Votre IBAN sera utilisé pour le virement de vos paiements.",
        "ownerLabel": "Titulaire du compte (optionnel)",
        "ibanLabel": "IBAN",
        "helper": "Exemple : PL76 3000 6000 0112 3456 7890 189",
        "save": "Enregistrer"
      },
      "errors": {
        "invalidIban": "IBAN invalide.",
        "saveFailed": "Impossible d’enregistrer l’IBAN."
      }
    },
    "profileMissing": {
      "text": "Votre profil d’expédition est incomplet. Merci de renseigner vos coordonnées sur votre profil pour finaliser vos ventes.",
      "button": "Compléter mon profil"
    },
    "inactive": {
      "title": "Cette transaction a été mise en pause par 123back",
      "editButton": "Modifier la transaction",
      "retentionPrefix": "Cette transaction sera supprimée le",
      "day": "jour",
      "days": "jours",
      "remaining": "restant",
      "remainingPlural": "restants"
    },
    "decision": {
      "button": "Décision sur le devis",
      "buttonDone": "Décision enregistrée",
      "dialogTitle": "Que souhaitez-vous faire ?",
      "dialogIntro": "Après le contrôle de vos pièces, choisissez la suite pour cette offre.",
      "processingNotice": "Confirmez l’acceptation du montant proposé. Après traitement, les pièces entièrement hors service devront être confiées aux filières ou personnes compétentes afin d’assurer leur recyclage et leur prise en charge dans de bonnes conditions.",
      "error": "Impossible d’enregistrer votre choix pour le moment.",
      "options": {
        "accept": {
          "title": "Valider l’offre",
          "desc": "Vous acceptez le montant validé, nous procédons au paiement."
        },
        "reject": {
          "title": "Refuser l’offre et récupérer mes pièces",
          "desc": "Vous refusez le montant validé et nous vous retournons vos pièces."
        },
        "return": {
          "title": "Valider l’offre et retourner les pièces HS, NF non rachetées",
          "desc": "Nous vous payons le montant validé et renvoyons les pièces non rachetées."
        }
      },
      "status": {
        "accepted": "Offre validée",
        "rejected": "Offre refusée — retour pièces",
        "acceptedWithReturn": "Offre validée + retour pièces HS, NF"
      },
      "summary": {
        "acceptWithReturnLabel": "Montant validé après contrôle + renvoi des pièces :"
      },
      "rejectWarning": {
        "title": "Confirmer le refus et le retour des pièces",
        "message": "En cas de refus de l’offre et de renvoi de vos pièces, nous pourrons être amenés à ne plus accepter vos prochains lots, en raison du coût de la logistique et du transport pris en charge par 123back.",
        "back": "Retour",
        "confirm": "Confirmer le refus et le renvoi"
      }
    }
  },
  "en": {
    "title": "My sales",
    "actions": {
      "refresh": "Refresh"
    },
    "loading": "Loading…",
    "empty": "No sales yet.",
    "emptyCta": {
      "title": "You don’t have any sales yet.",
      "subtitle": "Sell your phones in a few clicks and get paid quickly.",
      "button": "Sell now"
    },
    "info": {
      "waybillPending": "Your transport is being created. You will receive an email once it is generated."
    },
    "labels": {
      "shipment": "Sale",
      "createdAt": "Created on",
      "tracking": "Tracking",
      "trackingReturn": "Return tracking",
      "total": "Estimated total:",
      "paid": "Payment amount:",
      "buyback": "Validated amount:",
      "batchSort": "Send it! We'll sort it for you!"
    },
    "meta": {
      "packages": "packages",
      "pieces": "pieces"
    },
    "buttons": {
      "pdfRecap": "Recap PDF",
      "waybill": "Transport",
      "details": "Details",
      "hide": "Hide"
    },
    "status": {
      "sent": "Transport",
      "received": "Received",
      "quality": "Quality check",
      "pdf": "PDF",
      "paid": "Payment",
      "sentAt": "Versendet am:",
      "receivedAt": "Received:",
      "qualityCheckedAt": "Quality check:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Payment:"
    },
    "table": {
      "item": "Item",
      "unitPrice": "Unit (€)",
      "qty": "Qty",
      "total": "Total (€)"
    },
    "pdf": {
      "title": "Preview — Control PDF",
      "loading": "Loading PDF…",
      "unavailable": "PDF unavailable."
    },
    "waybill": {
      "title": "Preview — Transport",
      "loading": "Loading transport…",
      "unavailable": "Transport unavailable."
    },
    "files": {
      "shipment": "Sale",
      "waybill": "Transport"
    },
    "common": {
      "download": "Download",
      "openInTab": "Open in new tab",
      "close": "Close"
    },
    "errors": {
      "load": "Could not load your transactions."
    },
    "contact": {
      "text": "Need help? Email us at",
      "button": "Email",
      "inlineHelp": "Questions? Contact us:",
      "subject": "Question about my sale"
    },
    "filters": {
      "all": "All",
      "ongoing": "Ongoing",
      "past": "Completed",
      "sortLabel": "Sort",
      "emptyAfterFilter": "No sales match the filter.",
      "sort": {
        "newest": "Newest first",
        "oldest": "Oldest first",
        "amountDesc": "Amount (high → low)",
        "amountAsc": "Amount (low → high)"
      }
    },
    "badges": {
      "paid": "Paid"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": " (saved)",
      "toast": {
        "title": "Payment method saved",
        "subtitle": "Your IBAN has been stored successfully."
      },
      "confirm": {
        "title": "Use this payment method?",
        "savedIbanTitle": "Saved IBAN",
        "body": "We will use this IBAN to transfer your payment.",
        "changeIban": "Edit IBAN",
        "useThis": "Use"
      },
      "form": {
        "title": "Enter my IBAN",
        "info": "Your IBAN will be used for bank transfers.",
        "ownerLabel": "Account holder (optional)",
        "ibanLabel": "IBAN",
        "helper": "Example: PL76 3000 6000 0112 3456 7890 189",
        "save": "Save"
      },
      "errors": {
        "invalidIban": "Invalid IBAN.",
        "saveFailed": "Could not save the IBAN."
      }
    },
    "profileMissing": {
      "text": "Your shipping profile is incomplete. Please update your details in your profile to complete your sales.",
      "button": "Complete my profile"
    },
    "inactive": {
      "title": "This transaction has been paused by 123back",
      "editButton": "Edit transaction",
      "retentionPrefix": "This transaction will be deleted on",
      "day": "day",
      "days": "days",
      "remaining": "remaining",
      "remainingPlural": "remaining"
    },
    "decision": {
      "button": "Decision on the offer",
      "buttonDone": "Decision saved",
      "dialogTitle": "What would you like to do?",
      "dialogIntro": "After the quality check, choose what you want to do with this offer.",
      "processingNotice": "Confirm that you accept the proposed amount. After processing, completely unusable parts must be handed over to the appropriate recycling channels or qualified professionals so they can be handled responsibly.",
      "error": "We could not save your choice at the moment.",
      "options": {
        "accept": {
          "title": "Accept the offer",
          "desc": "You accept the validated amount, we proceed with the payment."
        },
        "reject": {
          "title": "Refuse the offer and get my parts back",
          "desc": "You refuse the validated amount and we send your parts back to you."
        },
        "return": {
          "title": "Accept the offer and return HS, NF non-bought parts",
          "desc": "We pay you the validated amount and return HS, NF parts we do not buy."
        }
      },
      "status": {
        "accepted": "Offer accepted",
        "rejected": "Offer refused — parts returned",
        "acceptedWithReturn": "Offer accepted + HS, NF parts returned"
      },
      "summary": {
        "acceptWithReturnLabel": "Validated amount after check + returned parts:"
      },
      "rejectWarning": {
        "title": "Confirm refusal and return of parts",
        "message": "If you refuse this offer and have your parts returned, we may no longer be able to accept your future lots, due to logistics and shipping costs covered by 123back.",
        "back": "Back",
        "confirm": "Confirm refusal and return"
      }
    }
  },
  "pl": {
    "title": "Moje sprzedaże",
    "actions": {
      "refresh": "Odśwież"
    },
    "loading": "Wczytywanie…",
    "empty": "Brak sprzedaży.",
    "emptyCta": {
      "title": "Nie masz jeszcze żadnych sprzedaży.",
      "subtitle": "Sprzedaj swoje telefony w kilka kliknięć i szybko otrzymaj płatność.",
      "button": "Sprzedaj teraz"
    },
    "info": {
      "waybillPending": "Twój transport jest tworzony. Otrzymasz e-mail po wygenerowaniu."
    },
    "labels": {
      "shipment": "Sprzedaż",
      "createdAt": "Utworzono",
      "tracking": "Śledzenie",
      "trackingReturn": "Śledzenie zwrotu",
      "total": "Suma szac.:",
      "paid": "Kwota płatności:",
      "buyback": "Kwota zatwierdzona:",
      "batchSort": "Wyślij! Posortujemy to za Ciebie!"
    },
    "meta": {
      "packages": "paczki",
      "pieces": "szt."
    },
    "buttons": {
      "pdfRecap": "PDF Podsum.",
      "waybill": "Versandetikett",
      "details": "Szczegóły",
      "hide": "Ukryj"
    },
    "status": {
      "sent": "Transport",
      "received": "Odebrano",
      "quality": "Kontrola",
      "pdf": "PDF",
      "paid": "Płatność",
      "sentAt": "Transport:",
      "receivedAt": "Odebrano:",
      "qualityCheckedAt": "Kontrola:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Płatność:"
    },
    "table": {
      "item": "Pozycja",
      "unitPrice": "Cena jedn. (€)",
      "qty": "Ilość",
      "total": "Suma (€)"
    },
    "pdf": {
      "title": "Podgląd — PDF kontroli",
      "loading": "Wczytywanie PDF…",
      "unavailable": "PDF niedostępny."
    },
    "waybill": {
      "title": "Podgląd — Transport",
      "loading": "Wczytywanie transportu…",
      "unavailable": "Transport niedostępny."
    },
    "files": {
      "shipment": "Sprzedaż",
      "waybill": "Transport"
    },
    "common": {
      "download": "Pobierz",
      "openInTab": "Otwórz w nowej karcie",
      "close": "Zamknij"
    },
    "errors": {
      "load": "Nie można wczytać transakcji."
    },
    "contact": {
      "text": "Potrzebujesz pomocy? Napisz do nas na",
      "button": "Napisz",
      "inlineHelp": "Masz pytanie? Skontaktuj się:",
      "subject": "Pytanie dotyczące sprzedaży"
    },
    "filters": {
      "all": "Wszystkie",
      "ongoing": "W toku",
      "past": "Zakończone",
      "sortLabel": "Sortuj",
      "emptyAfterFilter": "Brak sprzedaży dla wybranego filtra.",
      "sort": {
        "newest": "Najnowsze",
        "oldest": "Najstarsze",
        "amountDesc": "Kwota malejąco",
        "amountAsc": "Kwota rosnąco"
      }
    },
    "badges": {
      "paid": "Opłacona"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": " (zapisana)",
      "toast": {
        "title": "Metoda płatności zapisana",
        "subtitle": "Twój IBAN został zapisany."
      },
      "confirm": {
        "title": "Użyć tej metody płatności?",
        "savedIbanTitle": "Zapisany IBAN",
        "body": "Użyjemy tego IBAN do przelewu płatności.",
        "changeIban": "Zmień IBAN",
        "useThis": "Użyj"
      },
      "form": {
        "title": "Wpisz mój IBAN",
        "info": "Twój IBAN będzie używany do przelewów bankowych.",
        "ownerLabel": "Właściciel konta (opcjonalnie)",
        "ibanLabel": "IBAN",
        "helper": "Przykład: PL76 3000 6000 0112 3456 7890 189",
        "save": "Zapisz"
      },
      "errors": {
        "invalidIban": "Nieprawidłowy IBAN.",
        "saveFailed": "Nie udało się zapisać IBAN."
      }
    },
    "profileMissing": {
      "text": "Twój profil wysyłkowy jest niekompletny. Uzupełnij dane w swoim profilu, aby dokończyć sprzedaż.",
      "button": "Uzupełnij profil"
    },
    "inactive": {
      "title": "Ta transakcja została wstrzymana przez 123back",
      "editButton": "Edytuj transakcję",
      "retentionPrefix": "Ta transakcja zostanie usunięta dnia",
      "day": "dzień",
      "days": "dni",
      "remaining": "pozostał",
      "remainingPlural": "pozostało"
    },
    "decision": {
      "button": "Decyzja dotycząca oferty",
      "buttonDone": "Decyzja zapisana",
      "dialogTitle": "Co chcesz zrobić?",
      "dialogIntro": "Po kontroli jakości wybierz, co zrobić z tą ofertą.",
      "processingNotice": "Potwierdź akceptację proponowanej kwoty. Po przetworzeniu części całkowicie niezdatne do użytku należy przekazać odpowiednim podmiotom lub specjalistom, aby zapewnić ich prawidłowy recykling.",
      "error": "Nie udało się zapisać Twojej decyzji.",
      "options": {
        "accept": {
          "title": "Akceptuję ofertę",
          "desc": "Akceptujesz zatwierdzoną kwotę, realizujemy płatność."
        },
        "reject": {
          "title": "Odrzucam ofertę i chcę zwrot części",
          "desc": "Odrzucasz zatwierdzoną kwotę, a my odsyłamy Twoje części."
        },
        "return": {
          "title": "Akceptuję ofertę i zwrot części HS, NF nienabytych",
          "desc": "Wypłacamy zatwierdzoną kwotę i odsyłamy części HS, NF, których nie odkupujemy."
        }
      },
      "status": {
        "accepted": "Oferta zaakceptowana",
        "rejected": "Oferta odrzucona — części zwrócone",
        "acceptedWithReturn": "Oferta zaakceptowana + zwrot części HS, NF"
      },
      "summary": {
        "acceptWithReturnLabel": "Kwota zatwierdzona po kontroli + zwrot części:"
      },
      "rejectWarning": {
        "title": "Potwierdź odrzucenie oferty i zwrot części",
        "message": "W przypadku odrzucenia oferty i odesłania części możemy w przyszłości nie przyjmować kolejnych partii, ze względu na koszty logistyki i transportu ponoszone po naszej stronie.",
        "back": "Wróć",
        "confirm": "Potwierdź odrzucenie i zwrot"
      }
    }
  },
  "es": {
    "title": "Mis ventas",
    "actions": {
      "refresh": "Actualizar"
    },
    "loading": "Cargando…",
    "empty": "Aún no tienes ventas.",
    "emptyCta": {
      "title": "Todavía no tienes ninguna venta.",
      "subtitle": "Vende tus teléfonos en pocos clics y recibe tu pago rápidamente.",
      "button": "Vender ahora"
    },
    "info": {
      "waybillPending": "Tu transporte está siendo generado. Recibirás un correo cuando esté listo."
    },
    "labels": {
      "shipment": "Venta",
      "createdAt": "Creada el",
      "tracking": "Seguimiento",
      "trackingReturn": "Seguimiento de devolución",
      "total": "Total estimado:",
      "paid": "Importe del pago:",
      "buyback": "Importe validado:",
      "batchSort": "¡Envíalo! ¡Lo clasificamos por ti!"
    },
    "meta": {
      "packages": "paquetes",
      "pieces": "piezas"
    },
    "buttons": {
      "pdfRecap": "PDF Resumen",
      "waybill": "Transporte",
      "details": "Detalles",
      "hide": "Ocultar"
    },
    "status": {
      "sent": "Transporte",
      "received": "Recepción",
      "quality": "Control",
      "pdf": "PDF",
      "paid": "Pago",
      "sentAt": "Transporte:",
      "receivedAt": "Recepción:",
      "qualityCheckedAt": "Control:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Pago:"
    },
    "table": {
      "item": "Artículo",
      "unitPrice": "PU (€)",
      "qty": "Cant.",
      "total": "Total (€)"
    },
    "pdf": {
      "title": "Vista previa — PDF de control",
      "loading": "Cargando PDF…",
      "unavailable": "PDF no disponible."
    },
    "waybill": {
      "title": "Vista previa — Transporte",
      "loading": "Cargando transporte…",
      "unavailable": "Transporte no disponible."
    },
    "files": {
      "shipment": "Venta",
      "waybill": "Transporte"
    },
    "common": {
      "download": "Descargar",
      "openInTab": "Abrir en una pestaña",
      "close": "Cerrar"
    },
    "errors": {
      "load": "No se pudieron cargar tus ventas."
    },
    "contact": {
      "text": "¿Necesitas ayuda? Escríbenos a",
      "button": "Escribir",
      "inlineHelp": "¿Una pregunta? Contáctanos:",
      "subject": "Consulta sobre mi venta"
    },
    "filters": {
      "all": "Todas",
      "ongoing": "En curso",
      "past": "Finalizadas",
      "sortLabel": "Ordenar",
      "emptyAfterFilter": "Ninguna venta coincide con el filtro.",
      "sort": {
        "newest": "Más recientes",
        "oldest": "Más antiguas",
        "amountDesc": "Importe (mayor → menor)",
        "amountAsc": "Importe (menor → mayor)"
      }
    },
    "badges": {
      "paid": "Pagada"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": " (guardado)",
      "toast": {
        "title": "Método de pago guardado",
        "subtitle": "Tu IBAN ha sido registrado correctamente."
      },
      "confirm": {
        "title": "¿Usar este método de pago?",
        "savedIbanTitle": "IBAN guardado",
        "body": "Usaremos este IBAN para realizar tu transferencia.",
        "changeIban": "Modificar IBAN",
        "useThis": "Usar"
      },
      "form": {
        "title": "Introducir mi IBAN",
        "info": "Tu IBAN será utilizado para efectuar tus pagos.",
        "ownerLabel": "Titular de la cuenta (opcional)",
        "ibanLabel": "IBAN",
        "helper": "Ejemplo: PL76 3000 6000 0112 3456 7890 189",
        "save": "Guardar"
      },
      "errors": {
        "invalidIban": "IBAN inválido.",
        "saveFailed": "No se pudo guardar el IBAN."
      }
    },
    "profileMissing": {
      "text": "Tu perfil de envío está incompleto. Completa tus datos en tu perfil para finalizar tus ventas.",
      "button": "Completar mi perfil"
    },
    "inactive": {
      "title": "Esta transacción ha sido pausada por 123back",
      "editButton": "Modificar la transacción",
      "retentionPrefix": "Esta transacción se eliminará el",
      "day": "día",
      "days": "días",
      "remaining": "restante",
      "remainingPlural": "restantes"
    },
    "decision": {
      "button": "Decisión sobre el presupuesto",
      "buttonDone": "Decisión registrada",
      "dialogTitle": "¿Qué deseas hacer?",
      "dialogIntro": "Tras el control de tus piezas, elige qué hacer con esta oferta.",
      "processingNotice": "Confirma que aceptas el importe propuesto. Después del tratamiento, las piezas totalmente inutilizables deberán entregarse a los canales o profesionales adecuados para garantizar su reciclaje responsable.",
      "error": "No se pudo registrar tu decisión.",
      "options": {
        "accept": {
          "title": "Aceptar la oferta",
          "desc": "Aceptas el importe validado, procedemos al pago."
        },
        "reject": {
          "title": "Rechazar la oferta y recuperar mis piezas",
          "desc": "Rechazas el importe validado y te devolvemos tus piezas."
        },
        "return": {
          "title": "Aceptar la oferta y devolver las piezas HS, NF no compradas",
          "desc": "Te pagamos el importe validado y te devolvemos las piezas HS y NF no adquiridas."
        }
      },
      "status": {
        "accepted": "Oferta aceptada",
        "rejected": "Oferta rechazada — piezas devueltas",
        "acceptedWithReturn": "Oferta aceptada + devolución de piezas HS, NF"
      },
      "summary": {
        "acceptWithReturnLabel": "Importe validado tras control + devolución de piezas:"
      },
      "rejectWarning": {
        "title": "Confirmar el rechazo y la devolución de piezas",
        "message": "En caso de rechazar la oferta y solicitar la devolución de tus piezas, es posible que no podamos aceptar futuros lotes debido al coste logístico y de transporte asumido por 123back.",
        "back": "Volver",
        "confirm": "Confirmar rechazo y devolución"
      }
    }
  },
  "it": {
    "title": "Le mie vendite",
    "actions": {
      "refresh": "Rifiuti"
    },
    "loading": "Caricamento...",
    "empty": "Ancora nessuna vendita.",
    "emptyCta": {
      "title": "Non hai ancora vendite.",
      "subtitle": "Vendere i telefoni in pochi clic e ottenere pagato rapidamente.",
      "button": "Vendi ora"
    },
    "info": {
      "waybillPending": "Il tuo trasporto viene creato. Riceverai un'email una volta generata."
    },
    "labels": {
      "shipment": "Vendita",
      "createdAt": "Creato su",
      "tracking": "Monitoraggio",
      "trackingReturn": "Monitoraggio del ritorno",
      "total": "Totale stimato:",
      "paid": "Importo di pagamento:",
      "buyback": "Importo convalidato:",
      "batchSort": "Mandalo! La risolveremo!"
    },
    "meta": {
      "packages": "pacchetti",
      "pieces": "pezzi"
    },
    "buttons": {
      "pdfRecap": "Recap PDF",
      "waybill": "Trasporti",
      "details": "Dettagli",
      "hide": "Nascondi"
    },
    "status": {
      "sent": "Trasporti",
      "received": "Ricevuto",
      "quality": "Controllo qualità",
      "pdf": "PDF",
      "paid": "Pagamento",
      "sentAt": "Trasporti:",
      "receivedAt": "Ricevuto:",
      "qualityCheckedAt": "Controllo qualità:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Pagamento:"
    },
    "table": {
      "item": "Articolo",
      "unitPrice": "Unità (€)",
      "qty": "Qty",
      "total": "Totale"
    },
    "pdf": {
      "title": "Anteprima - Controllo PDF",
      "loading": "Caricamento PDF...",
      "unavailable": "PDF non disponibile."
    },
    "waybill": {
      "title": "Anteprima — Trasporti",
      "loading": "Trasporto di carico...",
      "unavailable": "Trasporti non disponibili."
    },
    "files": {
      "shipment": "Vendita",
      "waybill": "Trasporti"
    },
    "common": {
      "download": "Scarica",
      "openInTab": "Aprire nella nuova scheda",
      "close": "Chiudi"
    },
    "errors": {
      "load": "Non poteva caricare le sue transazioni."
    },
    "contact": {
      "text": "Ti serve aiuto? Inviaci un'email",
      "button": "Email",
      "inlineHelp": "Domande? Contattaci:",
      "subject": "Domanda sulla mia vendita"
    },
    "filters": {
      "all": "Tutti",
      "ongoing": "In corso",
      "past": "Completato",
      "sortLabel": "Ordina",
      "emptyAfterFilter": "Nessuna vendita corrisponde al filtro.",
      "sort": {
        "newest": "Nuovo primo",
        "oldest": "Il primo vecchio",
        "amountDesc": "Importo (alto → basso)",
        "amountAsc": "Importo (basso → alto)"
      }
    },
    "badges": {
      "paid": "Pagato"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": "(salvo)",
      "toast": {
        "title": "Metodo di pagamento salvato",
        "subtitle": "Il tuo IBAN è stato memorizzato con successo."
      },
      "confirm": {
        "title": "Utilizzare questo metodo di pagamento?",
        "savedIbanTitle": "Salvataggio IBAN",
        "body": "Useremo questo IBAN per trasferire il vostro pagamento.",
        "changeIban": "Modifica IBAN",
        "useThis": "Uso"
      },
      "form": {
        "title": "Inserisci il mio IBAN",
        "info": "Il vostro IBAN sarà utilizzato per i trasferimenti bancari.",
        "ownerLabel": "Titolare del conto (opzionale)",
        "ibanLabel": "IBAN",
        "helper": "Esempio: PL76 3000 6000 0112 3456 7890 189",
        "save": "Salva"
      },
      "errors": {
        "invalidIban": "IBAN non valido.",
        "saveFailed": "Non poteva salvare l'IBAN."
      }
    },
    "profileMissing": {
      "text": "Il tuo profilo di spedizione è incompleto. Aggiorna i tuoi dati nel tuo profilo per completare le tue vendite.",
      "button": "Completa il mio profilo"
    },
    "inactive": {
      "title": "Questa transazione è stata sospesa da 123back",
      "editButton": "Modifica transazione",
      "retentionPrefix": "Questa transazione verrà eliminata il",
      "day": "giorno",
      "days": "giorni",
      "remaining": "rimanente",
      "remainingPlural": "rimanenti"
    },
    "decision": {
      "button": "Decisione sull'offerta",
      "buttonDone": "Decisione salvata",
      "dialogTitle": "Cosa vorresti fare?",
      "dialogIntro": "Dopo il controllo di qualità, scegliere quello che si desidera fare con questa offerta.",
      "processingNotice": "Conferma l’accettazione dell’importo proposto. Dopo la lavorazione, i componenti completamente inutilizzabili dovranno essere affidati ai canali o ai professionisti competenti per garantirne il corretto riciclo.",
      "error": "Non potevamo salvare la tua scelta al momento.",
      "options": {
        "accept": {
          "title": "Accettare l'offerta",
          "desc": "Accetti l'importo convalidato, procediamo con il pagamento."
        },
        "reject": {
          "title": "Rifiutare l'offerta e riavere le mie parti",
          "desc": "Tu rifiuti l'importo convalidato e ti rispediamo le tue parti."
        },
        "return": {
          "title": "Accettare l'offerta e restituire HS, NF parti non dipendenti",
          "desc": "Vi paghiamo l'importo convalidato e restituiamo le parti HS, NF che non compriamo."
        }
      },
      "status": {
        "accepted": "Offerta accettata",
        "rejected": "Offerta rifiutata — ricambi restituiti",
        "acceptedWithReturn": "Offerta accettata + HS, ricambi NF restituiti"
      },
      "summary": {
        "acceptWithReturnLabel": "Importo convalidato dopo il controllo + parti restituite:"
      },
      "rejectWarning": {
        "title": "Confermare il rifiuto e il ritorno delle parti",
        "message": "Se rifiuti questa offerta e restituisci le tue parti, potremmo non essere più in grado di accettare i tuoi lotti futuri, a causa della logistica e dei costi di spedizione coperti da 123back.",
        "back": "Indietro",
        "confirm": "Confermare il rifiuto e il ritorno"
      }
    }
  },
  "de": {
    "title": "Meine Verkäufe",
    "actions": {
      "refresh": "Erfrischend"
    },
    "loading": "Beladung...",
    "empty": "Noch keine Verkäufe.",
    "emptyCta": {
      "title": "Sie haben noch keine Verkäufe.",
      "subtitle": "Verkaufen Sie Ihre Telefone mit wenigen Klicks und werden Sie schnell bezahlt.",
      "button": "Jetzt verkaufen"
    },
    "info": {
      "waybillPending": "Ihr Transport wird geschaffen. Sie erhalten eine E-Mail, sobald sie generiert wurde."
    },
    "labels": {
      "shipment": "Verkauf",
      "createdAt": "Erstellt am",
      "tracking": "Verfolgung",
      "trackingReturn": "Rückverfolgung",
      "total": "Geschätzter Gesamtbetrag:",
      "paid": "Zahlungsbetrag:",
      "buyback": "Validierter Betrag:",
      "batchSort": "Senden Sie es! Wir werden es für Sie sortieren!"
    },
    "meta": {
      "packages": "Packungen",
      "pieces": "Stücke"
    },
    "buttons": {
      "pdfRecap": "Recap PDF",
      "waybill": "Transport",
      "details": "Einzelheiten",
      "hide": "Hüllen"
    },
    "status": {
      "sent": "Transport",
      "received": "Empfangen",
      "quality": "Qualitätskontrolle",
      "pdf": "PDF",
      "paid": "Zahlung",
      "sentAt": "Transport:",
      "receivedAt": "Empfangen:",
      "qualityCheckedAt": "Qualitätskontrolle:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Zahlung:"
    },
    "table": {
      "item": "Position",
      "unitPrice": "Einheit (€)",
      "qty": "Qty",
      "total": "Gesamt (€)"
    },
    "pdf": {
      "title": "Vorschau - Control PDF",
      "loading": "PDF laden...",
      "unavailable": "PDF nicht verfügbar."
    },
    "waybill": {
      "title": "Vorschau — Verkehr",
      "loading": "Ladetransport...",
      "unavailable": "Transport nicht verfügbar."
    },
    "files": {
      "shipment": "Verkauf",
      "waybill": "Transport"
    },
    "common": {
      "download": "Herunterladen",
      "openInTab": "Öffnen im neuen Tab",
      "close": "Schließen"
    },
    "errors": {
      "load": "Konnte Ihre Transaktionen nicht laden."
    },
    "contact": {
      "text": "Brauchen Sie Hilfe? E-Mail an uns",
      "button": "E-Mail",
      "inlineHelp": "Fragen? Kontaktieren Sie uns:",
      "subject": "Frage zu meinem Verkauf"
    },
    "filters": {
      "all": "alle",
      "ongoing": "Laufende",
      "past": "Abgeschlossen",
      "sortLabel": "Sort",
      "emptyAfterFilter": "Keine Verkäufe passen zum Filter.",
      "sort": {
        "newest": "Neueste erste",
        "oldest": "Ältester Erster",
        "amountDesc": "Betrag (hoch → niedrig)",
        "amountAsc": "Betrag (niedrig → hoch)"
      }
    },
    "badges": {
      "paid": "Bezahlt"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": "(gerettet)",
      "toast": {
        "title": "Gespeicherte Zahlungsmethode",
        "subtitle": "Ihre IBAN wurde erfolgreich gespeichert."
      },
      "confirm": {
        "title": "Verwenden Sie diese Zahlungsmethode?",
        "savedIbanTitle": "Gespeicherte IBAN",
        "body": "Wir werden diese IBAN verwenden, um Ihre Zahlung zu überweisen.",
        "changeIban": "Edit IBAN",
        "useThis": "Verwendung"
      },
      "form": {
        "title": "Geben Sie meine IBAN ein",
        "info": "Ihre IBAN wird für Banküberweisungen verwendet.",
        "ownerLabel": "Kontoinhaber (fakultativ)",
        "ibanLabel": "IBAN",
        "helper": "Beispiel: PL76 3000 6000 0112 3456 7890 189",
        "save": "Sparen"
      },
      "errors": {
        "invalidIban": "Ungültige IBAN.",
        "saveFailed": "Ich konnte die IBAN nicht retten."
      }
    },
    "profileMissing": {
      "text": "Ihr Versandprofil ist unvollständig. Bitte aktualisieren Sie Ihre Daten in Ihrem Profil, um Ihren Verkauf abzuschließen.",
      "button": "Vervollständige mein Profil"
    },
    "inactive": {
      "title": "Diese Transaktion wurde von 123back angehalten",
      "editButton": "Transaktion bearbeiten",
      "retentionPrefix": "Diese Transaktion wird gelöscht am",
      "day": "Tag",
      "days": "Tage",
      "remaining": "verbleibend",
      "remainingPlural": "verbleibend"
    },
    "decision": {
      "button": "Entscheidung über das Angebot",
      "buttonDone": "Entscheidung gerettet",
      "dialogTitle": "Was würden Sie gerne tun?",
      "dialogIntro": "Wählen Sie nach der Qualitätskontrolle aus, was Sie mit diesem Angebot tun möchten.",
      "processingNotice": "Bestätigen Sie die Annahme des vorgeschlagenen Betrags. Vollständig unbrauchbare Teile müssen nach der Bearbeitung an geeignete Recyclingstellen oder Fachbetriebe übergeben werden, damit sie ordnungsgemäß verwertet werden.",
      "error": "Wir konnten Ihre Wahl im Moment nicht retten.",
      "options": {
        "accept": {
          "title": "Akzeptieren Sie das Angebot",
          "desc": "Sie akzeptieren den validierten Betrag, wir gehen mit der Zahlung fort."
        },
        "reject": {
          "title": "Lehnen Sie das Angebot ab und holen Sie meine Teile zurück",
          "desc": "Sie verweigern den validierten Betrag und wir senden Ihre Teile an Sie zurück."
        },
        "return": {
          "title": "Annahme des Angebots und Rückgabe HS, NF nicht gekaufte Teile",
          "desc": "Wir zahlen Ihnen den validierten Betrag und geben HS, NF Teile zurück, die wir nicht kaufen."
        }
      },
      "status": {
        "accepted": "Angebot angenommen",
        "rejected": "Angebot abgelehnt – Teile zurückgegeben",
        "acceptedWithReturn": "Angebot angenommen + HS, NF Teile zurückgegeben"
      },
      "summary": {
        "acceptWithReturnLabel": "Validierter Betrag nach Prüfung + zurückgegebene Teile:"
      },
      "rejectWarning": {
        "title": "Bestätigung der Ablehnung und Rückgabe von Teilen",
        "message": "Wenn Sie dieses Angebot ablehnen und Ihre Teile zurückgeben lassen, können wir Ihre zukünftigen Partien aufgrund von Logistik- und Versandkosten, die von 123back abgedeckt werden, möglicherweise nicht mehr akzeptieren.",
        "back": "Rücken",
        "confirm": "Ablehnung und Rückkehr bestätigen"
      }
    }
  },
  "pt": {
    "title": "As minhas vendas",
    "actions": {
      "refresh": "Actualizar"
    },
    "loading": "Carregando...",
    "empty": "Ainda não há vendas.",
    "emptyCta": {
      "title": "Você ainda não tem nenhuma venda.",
      "subtitle": "Vender seus telefones em alguns cliques e ser pago rapidamente.",
      "button": "Vende agora."
    },
    "info": {
      "waybillPending": "Seu transporte está sendo criado. Você receberá um e-mail uma vez gerado."
    },
    "labels": {
      "shipment": "Venda",
      "createdAt": "Criado em",
      "tracking": "Rastreamento",
      "trackingReturn": "Seguimento de retorno",
      "total": "Total estimado:",
      "paid": "Montante do pagamento:",
      "buyback": "Quantidade validada:",
      "batchSort": "Manda! Vamos resolver isto para ti!"
    },
    "meta": {
      "packages": "pacotes",
      "pieces": "peças"
    },
    "buttons": {
      "pdfRecap": "Recapitular PDF",
      "waybill": "Transportes",
      "details": "Detalhes",
      "hide": "Ocultar"
    },
    "status": {
      "sent": "Transportes",
      "received": "Recebido",
      "quality": "Verificação de qualidade",
      "pdf": "PDF",
      "paid": "Pagamento",
      "sentAt": "Versendet sou:",
      "receivedAt": "Recebido:",
      "qualityCheckedAt": "Verificação de qualidade:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Pagamento:"
    },
    "table": {
      "item": "Item",
      "unitPrice": "Unidade (€)",
      "qty": "Qty",
      "total": "Total (€)"
    },
    "pdf": {
      "title": "Visualização — Controle PDF",
      "loading": "Carregando PDF...",
      "unavailable": "PDF indisponível."
    },
    "waybill": {
      "title": "Antevisão — Transporte",
      "loading": "A carregar o transporte...",
      "unavailable": "Transporte indisponível."
    },
    "files": {
      "shipment": "Venda",
      "waybill": "Transportes"
    },
    "common": {
      "download": "Baixar",
      "openInTab": "Abrir numa página nova",
      "close": "Fechar"
    },
    "errors": {
      "load": "Não foi possível carregar as suas transacções."
    },
    "contact": {
      "text": "Precisas de ajuda? Envie-nos um e-mail para",
      "button": "E- mail",
      "inlineHelp": "Perguntas? Contacte-nos:",
      "subject": "Pergunta sobre a minha venda"
    },
    "filters": {
      "all": "Tudo",
      "ongoing": "Continuando",
      "past": "Concluído",
      "sortLabel": "Ordenar",
      "emptyAfterFilter": "Nenhuma venda corresponde ao filtro.",
      "sort": {
        "newest": "O mais novo primeiro",
        "oldest": "O mais velho primeiro",
        "amountDesc": "Quantidade (alto → baixo)",
        "amountAsc": "Quantidade (baixa → alta)"
      }
    },
    "badges": {
      "paid": "Pago"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": "(salvo)",
      "toast": {
        "title": "Método de pagamento salvo",
        "subtitle": "O seu IBAN foi armazenado com sucesso."
      },
      "confirm": {
        "title": "Usar este método de pagamento?",
        "savedIbanTitle": "IBAN salvo",
        "body": "Vamos usar este IBAN para transferir o seu pagamento.",
        "changeIban": "Editar IBAN",
        "useThis": "Utilização"
      },
      "form": {
        "title": "Entre no meu IBAN",
        "info": "O seu IBAN será utilizado para transferências bancárias.",
        "ownerLabel": "Titular da conta (facultativo)",
        "ibanLabel": "IBAN",
        "helper": "Exemplo: PL76 3000 6000 0112 3456 7890 189",
        "save": "Gravar"
      },
      "errors": {
        "invalidIban": "IBAN inválido.",
        "saveFailed": "Não foi possível salvar o IBAN."
      }
    },
    "profileMissing": {
      "text": "O seu perfil de envio está incompleto. Por favor, atualize seus detalhes em seu perfil para completar suas vendas.",
      "button": "Completar o meu perfil"
    },
    "inactive": {
      "title": "Esta transação foi pausada pelo 123back",
      "editButton": "Editar transação",
      "retentionPrefix": "Esta transacção será apagada em",
      "day": "dia",
      "days": "dias",
      "remaining": "restante",
      "remainingPlural": "restante"
    },
    "decision": {
      "button": "Decisão sobre a proposta",
      "buttonDone": "Decisão salva",
      "dialogTitle": "O que gostarias de fazer?",
      "dialogIntro": "Após a verificação de qualidade, escolha o que deseja fazer com esta oferta.",
      "processingNotice": "Confirme que aceita o montante proposto. Após o processamento, as peças completamente inutilizáveis devem ser entregues aos canais de reciclagem adequados ou aos profissionais qualificados para que possam ser manuseadas de forma responsável.",
      "error": "Não pudemos salvar sua escolha neste momento.",
      "options": {
        "accept": {
          "title": "Aceitar a oferta",
          "desc": "Você aceita o valor validado, nós procedemos com o pagamento."
        },
        "reject": {
          "title": "Recusa a oferta e recupera as minhas partes.",
          "desc": "Você recusa a quantidade validada e nós enviamos suas partes de volta para você."
        },
        "return": {
          "title": "Aceitar a oferta e devolver HS, NF peças não compradas",
          "desc": "Nós pagamos o valor validado e devolver HS, NF peças que não compramos."
        }
      },
      "status": {
        "accepted": "Oferta aceite",
        "rejected": "Oferta recusada — peças devolvidas",
        "acceptedWithReturn": "Oferta aceita + HS, NF peças devolvidas"
      },
      "summary": {
        "acceptWithReturnLabel": "Quantidade validada após verificação + peças devolvidas:"
      },
      "rejectWarning": {
        "title": "Confirmar recusa e devolução de peças",
        "message": "Se você recusar esta oferta e receber suas peças de volta, talvez não possamos mais aceitar seus futuros lotes, devido aos custos de logística e transporte cobertos pela 123back.",
        "back": "Voltar",
        "confirm": "Confirmar recusa e devolução"
      }
    }
  },
  "cs": {
    "title": "Moje prodeje",
    "actions": {
      "refresh": "Obnovit"
    },
    "loading": "Nabíjím...",
    "empty": "Zatím žádný prodej.",
    "emptyCta": {
      "title": "Ještě nemáš žádný prodej.",
      "subtitle": "Prodejte své telefony v několika kliknutí a dostanete zaplaceno rychle.",
      "button": "Prodat teď"
    },
    "info": {
      "waybillPending": "Váš transport byl vytvořen. Jakmile bude generován, obdržíte email."
    },
    "labels": {
      "shipment": "Prodej",
      "createdAt": "Vytvořeno",
      "tracking": "Sledování",
      "trackingReturn": "Zpětné sledování",
      "total": "Odhadovaný součet:",
      "paid": "Platební částka:",
      "buyback": "Platná částka:",
      "batchSort": "Pošli to! Vyřešíme to za tebe!"
    },
    "meta": {
      "packages": "balení",
      "pieces": "kusy"
    },
    "buttons": {
      "pdfRecap": "Rekapitalizovat PDF",
      "waybill": "Doprava",
      "details": "Podrobnosti",
      "hide": "Skrýt"
    },
    "status": {
      "sent": "Doprava",
      "received": "Přijato",
      "quality": "Kontrola kvality",
      "pdf": "PDF",
      "paid": "Platba",
      "sentAt": "Versendet am:",
      "receivedAt": "Přijato:",
      "qualityCheckedAt": "Kontrola kvality:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Platba:"
    },
    "table": {
      "item": "Položka",
      "unitPrice": "Jednotka (€)",
      "qty": "Qty",
      "total": "Celkem (v EUR)"
    },
    "pdf": {
      "title": "Náhled - Control PDF",
      "loading": "Načítám PDF...",
      "unavailable": "PDF není k dispozici."
    },
    "waybill": {
      "title": "Náhled - Doprava",
      "loading": "Nahrávání transportu...",
      "unavailable": "Transport není k dispozici."
    },
    "files": {
      "shipment": "Prodej",
      "waybill": "Doprava"
    },
    "common": {
      "download": "Stáhnout",
      "openInTab": "Otevřít v nové kartě",
      "close": "Zavřít"
    },
    "errors": {
      "load": "Nelze načíst transakce."
    },
    "contact": {
      "text": "Potřebuješ pomoc? Napište nám na email",
      "button": "E-mail",
      "inlineHelp": "Otázky? Kontaktujte nás:",
      "subject": "Otázka ohledně mého prodeje"
    },
    "filters": {
      "all": "Všechny",
      "ongoing": "Probíhá",
      "past": "Dokončeno",
      "sortLabel": "Třídit",
      "emptyAfterFilter": "Žádný prodej neodpovídá filtru.",
      "sort": {
        "newest": "Nejnovější",
        "oldest": "Nejstarší",
        "amountDesc": "Částka (vysoká → nízká)",
        "amountAsc": "Částka (nízká → vysoká)"
      }
    },
    "badges": {
      "paid": "Placené"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": "(uloženo)",
      "toast": {
        "title": "Uložená platební metoda",
        "subtitle": "Váš IBAN byl úspěšně uložen."
      },
      "confirm": {
        "title": "Použijete tuto platební metodu?",
        "savedIbanTitle": "Uložené IBAN",
        "body": "Použijeme IBAN k převodu vaší platby.",
        "changeIban": "Upravit IBAN",
        "useThis": "Použití"
      },
      "form": {
        "title": "Zadejte můj IBAN",
        "info": "Váš IBAN bude použit pro bankovní převody.",
        "ownerLabel": "Držitel účtu (nepovinné)",
        "ibanLabel": "IBAN",
        "helper": "Příklad: PL76 3000 6000 0112 3456 7890 189",
        "save": "Uložit"
      },
      "errors": {
        "invalidIban": "Neplatný IBAN.",
        "saveFailed": "Nelze zachránit IBAN."
      }
    },
    "profileMissing": {
      "text": "Váš přepravní profil není kompletní. Aktualizujte prosím své údaje ve svém profilu pro dokončení prodeje.",
      "button": "Dokončit můj profil"
    },
    "inactive": {
      "title": "Tuto transakci zastavila123back",
      "editButton": "Upravit transakci",
      "retentionPrefix": "Tato transakce bude zrušena dne",
      "day": "den",
      "days": "dny",
      "remaining": "zbývající",
      "remainingPlural": "zbývající"
    },
    "decision": {
      "button": "Rozhodnutí o nabídce",
      "buttonDone": "Uložené rozhodnutí",
      "dialogTitle": "Co bys chtěl dělat?",
      "dialogIntro": "Po kontrole kvality vyberte, co chcete s touto nabídkou dělat.",
      "processingNotice": "Potvrďte, že přijímáte navrhovanou částku. Po zpracování musí být zcela nepoužitelné díly předány příslušným recyklačním kanálům nebo kvalifikovaným odborníkům, aby s nimi bylo možné zacházet zodpovědně.",
      "error": "V tuto chvíli jsme nemohli zachránit vaši volbu.",
      "options": {
        "accept": {
          "title": "Přijměte nabídku",
          "desc": "Přijmete potvrzenou částku a my pokračujeme s platbou."
        },
        "reject": {
          "title": "Odmítněte nabídku a vraťte mi moje součástky.",
          "desc": "Odmítnete potvrzené množství a my vám pošleme vaše součástky zpět."
        },
        "return": {
          "title": "Přijmout nabídku a vrátit HS, NF nezakoupené díly",
          "desc": "Zaplatíme vám ověřenou částku a vrátíme HS, NF díly, které nekupujeme."
        }
      },
      "status": {
        "accepted": "Nabídka přijata",
        "rejected": "Nabídka zamítnuta - vrácené díly",
        "acceptedWithReturn": "Nabídka přijata + HS, NF díly vráceny"
      },
      "summary": {
        "acceptWithReturnLabel": "Platná částka po kontrole + vrácené části:"
      },
      "rejectWarning": {
        "title": "Potvrzení odmítnutí a vrácení částí",
        "message": "Pokud odmítnete tuto nabídku a necháte si vrátit své díly, možná již nebudeme moci akceptovat vaše budoucí parcely kvůli logistice a nákladům na dopravu, které hradí123back.",
        "back": "Zpět",
        "confirm": "Potvrdit odmítnutí a návrat"
      }
    }
  },
  "nl": {
    "title": "Mijn verkoop",
    "actions": {
      "refresh": "Verversen"
    },
    "loading": "Laden...",
    "empty": "Nog geen verkoop.",
    "emptyCta": {
      "title": "Je hebt nog geen verkoop.",
      "subtitle": "Verkoop uw telefoons in een paar klikken en krijg snel betaald.",
      "button": "Verkoop nu"
    },
    "info": {
      "waybillPending": "Uw transport wordt gecreëerd. U ontvangt een e-mail zodra het is gegenereerd."
    },
    "labels": {
      "shipment": "Verkoop",
      "createdAt": "Aangemaakt op",
      "tracking": "Tracking",
      "trackingReturn": "Tracking retourneren",
      "total": "Geraamde totaal:",
      "paid": "Betalingsbedrag:",
      "buyback": "Gevalideerd bedrag",
      "batchSort": "Stuur het! We regelen het wel."
    },
    "meta": {
      "packages": "verpakkingen",
      "pieces": "stuks"
    },
    "buttons": {
      "pdfRecap": "PDF hercaperen",
      "waybill": "Vervoer",
      "details": "Gegevens",
      "hide": "Verbergen"
    },
    "status": {
      "sent": "Vervoer",
      "received": "Ontvangen",
      "quality": "Kwaliteitscontrole",
      "pdf": "PDF",
      "paid": "Betaling",
      "sentAt": "Versendet am:",
      "receivedAt": "Ontvangen:",
      "qualityCheckedAt": "Kwaliteitscontrole:",
      "pdfRecapAt": "PDF:",
      "paidAt": "Betaling:"
    },
    "table": {
      "item": "Post",
      "unitPrice": "Eenheid (€)",
      "qty": "Aantal",
      "total": "Totaal (€)"
    },
    "pdf": {
      "title": "Voorbeeld van de controle PDF",
      "loading": "PDF wordt geladen...",
      "unavailable": "PDF niet beschikbaar."
    },
    "waybill": {
      "title": "Voorbeeld",
      "loading": "Transport laden...",
      "unavailable": "Vervoer is niet beschikbaar."
    },
    "files": {
      "shipment": "Verkoop",
      "waybill": "Vervoer"
    },
    "common": {
      "download": "Downloaden",
      "openInTab": "In nieuw tabblad openen",
      "close": "Sluiten"
    },
    "errors": {
      "load": "Kon uw transacties niet laden."
    },
    "contact": {
      "text": "Hulp nodig? E-mail ons op",
      "button": "E-mail",
      "inlineHelp": "Vragen? Contacteer ons:",
      "subject": "Vraag over mijn verkoop"
    },
    "filters": {
      "all": "Alles",
      "ongoing": "Lopende",
      "past": "Voltooid",
      "sortLabel": "Sorteren",
      "emptyAfterFilter": "Geen verkoop komt overeen met het filter.",
      "sort": {
        "newest": "Eerste nieuwste",
        "oldest": "Oudste eerst",
        "amountDesc": "Bedrag (hoog → laag)",
        "amountAsc": "Bedrag (laag → hoog)"
      }
    },
    "badges": {
      "paid": "Betaald"
    },
    "iban": {
      "button": "IBAN",
      "buttonSavedSuffix": "(opgeslagen)",
      "toast": {
        "title": "Betaalmethode opgeslagen",
        "subtitle": "Uw IBAN is succesvol opgeslagen."
      },
      "confirm": {
        "title": "Gebruik je deze betaalmethode?",
        "savedIbanTitle": "Opgeslagen IBAN",
        "body": "We zullen dit IBAN gebruiken om uw betaling over te dragen.",
        "changeIban": "IBAN bewerken",
        "useThis": "Gebruik"
      },
      "form": {
        "title": "Vul mijn IBAN in",
        "info": "Uw IBAN wordt gebruikt voor bankoverschrijvingen.",
        "ownerLabel": "Rekeninghouder (facultatief)",
        "ibanLabel": "IBAN",
        "helper": "Voorbeeld: PL76 3000 6000 0112 3456 7890 189",
        "save": "Opslaan"
      },
      "errors": {
        "invalidIban": "Ongeldig IBAN.",
        "saveFailed": "Kon het IBAN niet opslaan."
      }
    },
    "profileMissing": {
      "text": "Uw verzendingsprofiel is onvolledig. Update uw gegevens in uw profiel om uw verkoop te voltooien.",
      "button": "Mijn profiel invullen"
    },
    "inactive": {
      "title": "Deze transactie is gepauzeerd door123back",
      "editButton": "Transactie bewerken",
      "retentionPrefix": "Deze transactie wordt verwijderd op",
      "day": "dag",
      "days": "dagen",
      "remaining": "resterende",
      "remainingPlural": "resterende"
    },
    "decision": {
      "button": "Besluit over het aanbod",
      "buttonDone": "Opgeslagen beslissing",
      "dialogTitle": "Wat wil je doen?",
      "dialogIntro": "Na de kwaliteitscontrole, kies wat u wilt doen met dit aanbod.",
      "processingNotice": "Bevestig dat u het voorgestelde bedrag accepteert. Na verwerking moeten volledig onbruikbaar onderdelen worden overgedragen aan de geschikte recyclingkanalen of gekwalificeerde professionals, zodat ze verantwoord kunnen worden behandeld.",
      "error": "We konden je keuze op dit moment niet redden.",
      "options": {
        "accept": {
          "title": "Aanvaard het aanbod",
          "desc": "U accepteert het gevalideerde bedrag, wij gaan door met de betaling."
        },
        "reject": {
          "title": "Weiger het aanbod en krijg mijn onderdelen terug.",
          "desc": "U weigert het gevalideerde bedrag en wij sturen uw onderdelen terug naar u."
        },
        "return": {
          "title": "Accepteer het aanbod en retourneer HS, NF niet-gekochte onderdelen",
          "desc": "Wij betalen u het gevalideerde bedrag en retourneren HS, NF onderdelen die wij niet kopen."
        }
      },
      "status": {
        "accepted": "Aanbod aanvaard",
        "rejected": "Aanbieding geweigerde onderdelen teruggegeven",
        "acceptedWithReturn": "Aanbod geaccepteerd + GS, NF-onderdelen teruggegeven"
      },
      "summary": {
        "acceptWithReturnLabel": "Gevalideerd bedrag na controle + geretourneerde delen:"
      },
      "rejectWarning": {
        "title": "Bevestig weigering en teruggave van onderdelen",
        "message": "Als u dit aanbod weigert en uw onderdelen teruggeeft, kunnen wij uw toekomstige kavels niet langer accepteren vanwege de logistieke en verzendkosten van123back.",
        "back": "Terug",
        "confirm": "Bevestig weigering en terugkeer"
      }
    }
  }
};

export default accountTransactionsI18n;
